import Avatar from "@material-ui/core/Avatar";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Drawer from "@material-ui/core/Drawer";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import useQueues from "../../hooks/useQueues";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { Tooltip } from "@mui/material";
import { Dialog } from "@mui/material";
import SingleSelect from "../InputStyled/singleSelect";

const drawerWidth = 320;
const useStyles = makeStyles(theme => ({
	drawer: {
		width: "0px",
		flexShrink: 0,
		transitionDuration: "0.3s"
	},
	maxWidth: {
		width: "100%",
	},
	drawerPaper: {
		width: drawerWidth,
		display: "flex",
		borderTop: "1px solid rgba(0, 0, 0, 0.12)",
		borderRight: "1px solid rgba(0, 0, 0, 0.12)",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		borderTopRightRadius: 4,
		borderBottomRightRadius: 4,
	},


	header: {
		marginTop: "60px",
		display: "flex",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		backgroundColor: "#eee",
		alignItems: "center",
		padding: theme.spacing(0, 1),
		minHeight: "73px",
		justifyContent: "flex-start",
	},
	content: {
		display: "flex",
		backgroundColor: "#eee",
		flexDirection: "column",
		padding: "8px 0px 8px 8px",
		height: "100%",
		overflowY: "scroll",
		...theme.scrollbarStyles,
	},

	contactAvatar: {
		margin: 15,
		width: 100,
		height: 100,
	},

	contactHeader: {
		display: "flex",
		padding: 8,
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		"& > *": {
			margin: 4,
		},
	},

	contactDetails: {
		marginTop: 8,
		padding: 8,
		paddingTop: 25,
		display: "flex",
		flexDirection: "column",
	},
	contactExtraInfo: {
		marginTop: 4,
		padding: 6,
	},
	button100: {
		width: "100%"
	},
	userState: {
		padding: '0',
		borderRadius: '100%',
		marginRight: '5px',
		boxShadow: 'box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;background-color: rgb(66, 66, 66)',
		height: '10px',
		width: '10px',
		display: 'inline-block',
	}

}));

const ContactDrawer = ({ open, onClose, contact, ticket, isDialog, user, byTicketManagement = false }) => {
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [queues, setQueues] = useState([]);
	const [selectedQueue, setSelectedQueue] = useState('');
	const [users, setUsers] = useState([]);
	const [selectedUser, setSelectedUser] = useState('');
	const classes = useStyles();

	const handleSaveTicket = async e => {

		if (!ticket.id) return;

		if (!selectedQueue || selectedQueue == '') {
			toast.error("Selecione uma fila para transferir.")
			return;
		}

		setLoading(true);
		try {
			let data = {
				transfer: 1,
				userId: selectedUser,
				queueId: selectedQueue
			};
			await api.put(`/tickets/${ticket.id}`, data);
			setLoading(false);

			if (!isDialog && byTicketManagement != true) history.push(`/tickets`);
			else {
				modalTransferClose(e);
			}
		} catch (err) {
			console.error({err});
			setLoading(false);
			toastError(err);
		}
	};

	const clearInputs = () => {
		setSelectedQueue('');
		setSelectedUser('');
		setUsers([]);
		setQueues([]);
	}

	function modalTransferClose(e) {
		onClose(e);
		if (document.querySelector("#ModalTransfer")) document.querySelector("#ModalTransfer").style = "width: 0px !important;"
	}

	function isOnline(usr) {
		let statusColor;
		let key = new Date().getTime();
		let check = usr.state;
		let name = usr.name;

		switch (String(check).toLocaleLowerCase()) {
			case 'online':
				statusColor = '#4caf50';
				break;
			case 'out':
				statusColor = '#ff9800';
				break;
			default:
				statusColor = '#f44336';
				break;
		}

		return (
			<>
				<Typography
					component="span"
					key={key}
					className={classes.userState}
					style={{ background: statusColor }}
				/>
				{name}
			</>
		);
	}

	useEffect(() => {
		if (open != true || !ticket || !contact) {
			clearInputs();
			return;
		}

		let isMounted = true;
        const abortController = new AbortController();

		(async () => {
			try {
				const { data } = await api.get(`queueListWithConnections/${ticket.whatsappId}`, {
					signal: abortController.signal,
				});
				if (isMounted) setQueues(data);
			} catch (err) {
				if (!isMounted || err.name == 'AbortError') return;
				console.error({ err });
				toastError(err);
			}
		})();

		if (!user || !user?.completeConnectionsAndQueues || !Array.isArray(user.completeConnectionsAndQueues) || user.completeConnectionsAndQueues.length == 0) return;

		if (window.innerWidth > 560) if (document.querySelector("#ModalTransfer")) document.querySelector("#ModalTransfer").style = "width: 320px !important;"

		return () => {
            isMounted = false;
            abortController.abort();
        };

	}, [open]);

	useEffect(() => {
		if (!selectedQueue || selectedQueue == '' || !ticket) return;

		let isMounted = true;
		const abortController = new AbortController();

		(async () => {
			try {
				setLoading(true);
				const { data } = await api.get("/users-dropDown", {
					params: { connectionId: ticket.whatsappId, queueId: selectedQueue },
					signal: abortController.signal,
				});
				if (!isMounted || !data) return;

				// remover usuário atual
				setUsers(data);
			} catch (err) {
				console.error({ err });
				toastError(err);
			} finally {
				setLoading(false);
			}
		})();

		return () => {
			isMounted = false;
			abortController.abort();
		};
	}, [selectedQueue]);

	const renderQueueOptions = () => {
		const response = [];
		if (Array.isArray(queues) && ticket) {
			queues.map((q) => {
				response.push({
					key: q.id,
					value: q.name,
					disabled: false
				});
			});
		}
		return response;
	}

	const renderUserOptions = () => {
		const response = [];
		if (Array.isArray(users)) {
			users.map((u) => {
				response.push({
					key: u.id,
					value: u.name,
					customValue: isOnline(u),
					disabled: false
				});
			});
		}
		return response;
	}

	const renderContent = () => {
		return (
			<>
				<div className={classes.header}>
					<IconButton
						id="closeModalTransfer"
						onClick={(e) => modalTransferClose(e)}
					>
						<CloseIcon />
					</IconButton>
					<Typography style={{ justifySelf: "center" }}>
						{i18n.t("contactDrawer.headerTransfer")}
					</Typography>
				</div>
				<div className={classes.content}>
					{
						!isDialog &&
						<Paper square variant="outlined" className={classes.contactHeader}>
							<Avatar
								alt={contact.name}
								src={contact.profilePicUrl}
								className={classes.contactAvatar}
							></Avatar>
							<Typography>{contact.name}</Typography>
							<Typography>
								<Link href={`https://api.whatsapp.com/send?phone=${contact.number}`}>{contact.number}</Link>
							</Typography>
						</Paper>
					}
					<Paper square variant="outlined" className={classes.contactDetails} scroll="paper">
						<DialogContent
							style={{ padding: '6px', marginTop: -20, overflowY: 'hidden' }}
						>
							<SingleSelect 
								title={
									<Typography>
										Fila de Atendimento
										<Typography component="span" style={{ marginLeft: '5px' }} color="secondary">*</Typography>
									</Typography>
								}
								displayText={"selecionar fila"}
								name="contactTransferQueue"
								key="contactTransferQueue"
								options={renderQueueOptions()}
								onSelected={(opt) => setSelectedQueue(opt)}
								selected={selectedQueue}
								closeOnSelect={true}
							/>
							<SingleSelect
								title={
									<Typography>
										Usuário
									</Typography>
								}
								displayText={"selecionar usuário"}
								name="contactTransferUser"
								key="contactTransferUser"
								options={renderUserOptions()}
								onSelected={(opt) => setSelectedUser(opt)}
								selected={selectedUser}
								disabled={!selectedQueue || selectedQueue == "" ? true : false}
								closeOnSelect={false}
								toggleOnReselect={true}
							/>
						</DialogContent>
						<DialogActions dividers>
							<ButtonWithSpinner
								className={classes.button100}
								variant="contained"
								type="submit"
								color="primary"
								loading={loading}
								disabled={!selectedQueue || selectedQueue == "" || loading ? true : false}
								onClick={() => handleSaveTicket()}
							>
								{i18n.t("transferTicketModal.buttons.ok")}
							</ButtonWithSpinner>
						</DialogActions>
					</Paper>
				</div>
			</>
		);
	}

	return (
		<>
			{
				isDialog == true ?
					<Dialog
						open={open == true ? true : false}
						onClose={onClose}
						aria-labelledby="ModalTransfer"
						size="sm"
						fullWidth
					>
						{renderContent()}
					</Dialog>
					:
					<Drawer
						className={classes.drawer}
						variant="persistent"
						anchor="right"
						id="ModalTransfer"
						open={open == true ? true : false}
						classes={{
							paper: classes.drawerPaper,
						}}
					>
						{renderContent()}
					</Drawer >
			}
		</>
	);
};

export default ContactDrawer;
